import { render, staticRenderFns } from "./ChatSwitcher.vue?vue&type=template&id=59b509c5&scoped=true&"
import script from "./ChatSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ChatSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ChatSwitcher.vue?vue&type=style&index=0&id=59b509c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b509c5",
  null
  
)

export default component.exports